// extracted by mini-css-extract-plugin
module.exports = {"mapPart":"style_mapPart__o1sC4","map":"style_map__J-luF","image":"style_image__1PLG1"};